@if (canShowPurchaseOrderPanel) {
  <purchase-order-panel (closePanelEvent)="fnClosePurchaseOrderPanel()"></purchase-order-panel>
} @else {
  <ds-modal [modalInput]="modalConfig">
    <ng-container class="modal-content-wrapper" modal-body>
      @if (!isDemoBooked) {
        <p>{{ 'new_onb_trial_over_line1' | translate:{ days: (basicFunctionTrialDays ?? 0) } }}</p>
        <p>{{ 'new_onb_trial_account_active' | translate }} <span class="text-error">{{ 'new_onb_permanently_deleted' | translate }}</span>.</p>
      } @else {
        <p>{{ 'new_onb_demo_sent_pre' | translate }} <b>{{ 'new_onb_contact_you' | translate }}</b> {{ 'new_onb_demo_sent_post' | translate }}</p>
      }
    </ng-container>
    <ng-container modal-footer>
      @if (!isDemoBooked) {
        <ds-button [buttonInput]="requestDemoButton" (btnClick)="fnRequestDemo()"></ds-button>
      } @else {
        <ds-button [buttonInput]="logoutButton" (btnClick)="fnLogout()"></ds-button>
      }
    </ng-container>
  </ds-modal>
}
